import React from 'react';
import css from '../EditListingDescriptionForm.css';
import css_local from './EditListingDescriptionPageEight.css';
import CustomFormField from '../../CustomFormField/CustomFormField';
import { skills_general as skillsOptionsGeneral } from '../../../marketplace-custom-config';
import { skills_experience as skillsOptionsExperience } from '../../../marketplace-custom-config';
import classNames from 'classnames';

export const SKILLS_CUSTOM_FIELD_NAME = 'skillsCustom';
export const SKILLS_CUSTOM_FIELD_NAME_SECONDARY = 'skillsCustomSecondary';

const EditListingDescriptionPageEight = props => (
    <div>
        <h1 className={css.horseTypeTitle}>Was ist dir sonst noch wichtig?</h1>
        <p className={css.horseTypeSubTitle}>
            Wähle aus, was die Person zusätzlich mitbringen sollte.
        </p>
        <div className={css.marginWrapper}>
            <section className={classNames(css_local.subSection, css_local.subSectionPrimary)}>
                <h3>Allgemein</h3>
                <p>Das zeichnet die Person aus:</p>
                <CustomFormField
                    fieldName="skillsGeneral"
                    customFieldName={SKILLS_CUSTOM_FIELD_NAME}
                    nonCustomOptions={skillsOptionsGeneral}
                    options={skillsOptionsGeneral}
                    customFieldPlaceholderId="EditListingDescriptionForm.permittedActivitiesAddCustomOption"
                    {...props}
                />
            </section>
            <section className={css_local.subSection}>
                <h3>Umgang</h3>
                <p>Die Person hat Erfahrung mit:</p>
                <CustomFormField
                    fieldName="skillsExperience"
                    customFieldName={SKILLS_CUSTOM_FIELD_NAME_SECONDARY}
                    nonCustomOptions={skillsOptionsExperience}
                    options={skillsOptionsExperience}
                    customFieldPlaceholderId="EditListingDescriptionForm.permittedActivitiesAddCustomOption"
                    {...props}
                />
            </section>
        </div>
    </div>
);

export default EditListingDescriptionPageEight;
